import { render, staticRenderFns } from "./CommentsChapter.vue?vue&type=template&id=7491d504&scoped=true"
import script from "./CommentsChapter.vue?vue&type=script&lang=js"
export * from "./CommentsChapter.vue?vue&type=script&lang=js"
import style0 from "./CommentsChapter.vue?vue&type=style&index=0&id=7491d504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7491d504",
  null
  
)

export default component.exports